// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35u20","input":"styles_input__1Po0-"};